/**
 * Governance block reasons — the vocabulary, with nothing attached to it.
 *
 * These values live here rather than in `governance-enforcer.js` for the same reason
 * `outcome-vocabulary` and `retired-engagement-types` are their own modules: a *vocabulary*
 * is read by things that have no business loading the machinery that produces it.
 *
 * Concretely, `governance-enforcer` builds a DynamoDB client and reads `DEFAULT_QUIET_HOURS`
 * at module load. When `schemas.js` began importing the D2 decision vocabulary (O1 item 4),
 * and that vocabulary imported the enforcer for these nine strings, every consumer of
 * `schemas.js` — which is very nearly everything, tests included — started instantiating an
 * AWS client and loading the SMS compliance stack as a side effect of describing a table.
 * One service test suite failed to load before a single test ran.
 *
 * `governance-enforcer` re-exports `BLOCK_REASONS`, so every existing importer is unchanged
 * and there is still exactly one definition.
 *
 * @module block-reasons
 */

/** Block reasons. `*_check_failed` are the fail-closed outcomes. */
const BLOCK_REASONS = Object.freeze({
  BLACKOUT: 'blackout',
  QUIET_HOURS: 'quiet_hours',
  COOLDOWN: 'cooldown',
  FREQUENCY_CAP_WEEK: 'frequency_cap_week',
  FREQUENCY_CAP_MONTH: 'frequency_cap_month',
  FATIGUE: 'fatigue',
  SUPPRESSED: 'suppressed',
  // The person was erased (MAR-251/MAR-345): their tombstone exists, so nothing may be sent
  // to them, whatever was decided before the erasure landed. `suppressed`, never `failed`.
  SUBJECT_ERASED: 'subject_erased',
  // fail-closed
  ENGAGEMENT_HISTORY_READ_FAILED: 'engagement_history_read_failed',
  SUPPRESSION_CHECK_FAILED: 'suppression_check_failed'
});

module.exports = { BLOCK_REASONS };
